import { memo, useCallback } from 'react';
import { Placemark } from '@pbe/react-yandex-maps';

import marker from './marker.svg';

import type { FC } from 'react';
import type { BasePlacemark } from '@Types/Map';
import type { PickupPointData } from '@Types/PickupPoint';

export interface PecomMapPlacemarkProps extends BasePlacemark {
  sellPoint: PickupPointData;
  onClickPlacemark?: (e: MouseEvent, sellPoint: PickupPointData) => void;
}

const PecomMapPlacemark: FC<PecomMapPlacemarkProps> = (props) => {
  const { sellPoint, onClickPlacemark, ...restProps } = props;

  const handleClick = useCallback(
    (e: MouseEvent) => {
      if (onClickPlacemark) onClickPlacemark(e, sellPoint);
    },
    [sellPoint, onClickPlacemark],
  );

  return (
    <Placemark
      {...restProps}
      modules={['geoObject.addon.balloon']}
      properties={{
        balloonContent: sellPoint.address,
      }}
      geometry={sellPoint.coordinates}
      options={{
        iconLayout: 'default#image',
        iconImageHref: marker,
        iconImageSize: [52, 44],
        iconImageOffset: [-26, -46],
        zIndex: 1,
        zIndexHover: 3,
      }}
      onClick={handleClick}
    />
  );
};

export default memo(PecomMapPlacemark);
